<template>
	<div>
		<el-dialog :title="dataActionBox.boxTitle" :visible.sync="dataActionBox.showStatus" append-to-body top="2rem" width="80%" center :before-close="initActionBox">
			
			<el-form :model="sendDataInfo" v-if="formData" label-width="120px" size="mini" ref="sendDataInfo" :show-message="false">
				<el-row>
					<el-col :span="formOneValue.entityField == 'cbiState' || formOneValue.entityField == 'cbiAddress' ?  24 :12" v-for="(formOneValue,formOneKey) in formData.jurconfigform" :key="formOneKey" >
				
						<el-form-item v-if="formOneValue.isShow==1" :label="formOneValue.showField" :prop="formOneValue.entityField"
						:rules="formOneValue.isRequired == 1 ? [{required: true, trigger: ['blur', 'change']}] : []">
                        <label slot="label" :style="$common.labelStyle(formOneValue.showField)" v-html="$common.htmlLabel(formOneValue.showField)"></label>
							<!-- 系统字段 -->
							<div v-if="formOneValue.isReserved == 0">
								<el-input v-if="formOneValue.entityField == 'cbiAddress'" type="textarea" placeholder="请输入内容" v-model="sendDataInfo[formOneValue.entityField]" maxlength="64" show-word-limit clearable></el-input>

								<el-radio-group  v-else-if="formOneValue.entityField == 'cbiState'"  v-model="sendDataInfo[formOneValue.entityField]">
									<el-radio-button :label="0">禁用</el-radio-button>
									<el-radio-button :label="1">启用</el-radio-button>
								</el-radio-group>
								<el-input v-else  v-model.trim="sendDataInfo[formOneValue.entityField]" maxlength="64" clearable></el-input>
								
							</div>
							<!-- 扩展字段 -->
							<div v-if="formOneValue.isReserved == 1">
								
								<!-- 自填 -->
								<el-input v-model.trim="sendDataInfo[formOneValue.entityField]" v-if="formOneValue.operatType == 0"  maxlength="64" clearable></el-input>
								<!-- 选择数据来源 -->
								<el-input v-model.trim="sendDataInfo[formOneValue.entityField]"  v-else  maxlength="64" clearable></el-input>
							</div>
						</el-form-item>
					</el-col>
				</el-row>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="initActionBox">取 消</el-button>
				<el-button type="primary" @click="sendDataAction('sendDataInfo')">确 定</el-button>
			</div>
		</el-dialog>
	</div>
	
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
export default {
	name:'customerBank',
	// props:['formData'],
    //import引入的组件需要注入到对象中才能使用
    components: {},
    data() {
        //这里存放数据
        return {
			dataActionBox:{
				showStatus:false,
				openMode:'ltr'||'rtl',
				boxTitle:'新增'||'编辑',
				actionType:0, // 0新增，1修改
			},
			sendDataInfo:{
			  "cbiAddress": "",
			  "cbiCode": "",
			  "cbiCreater": 0,
			  "cbiName": "",
			  "cbiNumber": "",
			  "cbiReserves1": "",
			  "cbiReserves2": "",
			  "cbiReserves3": "",
			  "cbiReserves4": "",
			  "cbiReserves5": "",
			  "cbiReserves6": "",
			  "cbiState": 0,
			  "cbiTelnumber": "",
			  "cmId": 0
			},
			formData:{},
			
			
        };
    },
    //监听属性 类似于data概念
    computed: {
	},
    //监控data中的数据变化
    watch: {},
    //方法集合
    methods: {
		// 新增或修改
		sendDataAction(formName){
			let flag = false
			this.$refs[formName].validate((valid) => {
				if (valid) {
				} else {
					this.$message({
						message: '请完善必填信息',
						type: 'error'
					})
					flag = true
					return false;
				}
			})
			if(flag) return false;
			let sendData = JSON.parse(JSON.stringify(this.sendDataInfo))
			this.$emit('returnBank',sendData,this.dataActionBox.actionType)
			this.dataActionBox.showStatus = false
			this.$refs[formName].resetFields()
			this.init()

			// if(this.dataActionBox.actionType==0){
			// 	var responseData =  await this.$http.addCusmasterBank(sendData)
			// }else{
			// 	sendData.cmModifier = this.$store.getters.getUserInfo.opmId
			// 	var responseData =  await this.$http.setCusmasterBank(sendData)
			// }
		},
		isShowData(name,value){
			this.sendDataInfo[name] = value
		},
		//取消
		initActionBox(){
			this.$confirm("确定取消"+this.dataActionBox.boxTitle+"吗?", "提示", {
			confirmButtonText: "确定",
			cancelButtonText: "取消",
			type: "warning",
			})
			.then(() => {
				this.dataActionBox.showStatus = false
				this.$refs['sendDataInfo'].resetFields()
				this.init()
			})
			.catch(() => {})
		},
		//初始化
		init(){
			for(let key in this.sendDataInfo){
				this.sendDataInfo[key]  = ''
			}
			
			this.sendDataInfo.sbiState = 0
			this.dataActionBox.actionType = 0
		},
		//父级传入
		openBox(cate,formData,mainId,oldData=''){
			this.formData = formData
			this.init()
			this.sendDataInfo.cmId = mainId
			if(cate == 0){
				this.dataActionBox.boxTitle = '新增银行卡信息'
				this.dataActionBox.openMode = 'ltr'
			}else{
				this.dataActionBox.boxTitle = '编辑银行卡信息'
				this.dataActionBox.openMode = 'rtl'
				for(let key in oldData){
					this.sendDataInfo[key]  = oldData[key]
				}
				
			}
			this.dataActionBox.actionType = cate
			this.dataActionBox.showStatus = true
			
		},
		
	
		
		
		
		
		
		
    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {
    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {
    },
    beforeCreate() {
	}, //生命周期 - 创建之前
    beforeMount() {
	}, //生命周期 - 挂载之前
    beforeUpdate() {
	}, //生命周期 - 更新之前
    updated() {
	}, //生命周期 - 更新之后
    beforeDestroy() {
	}, //生命周期 - 销毁之前
    destroyed() {
	}, //生命周期 - 销毁完成
    activated() {
	}, //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style>

</style>